import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import {
    TravelProductService,
    TravelPackage,
    UpdateInclusionsOptions,
    AddTourToBookingOption,
    UpdateTourOnBookingOption,
    FareTypeChangedEvent,
    ProductType,
    AddProductAndPassengerToBookingOptions
} from '../../../services/travel-product.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ActionUpdaterService, ApiError } from '../../../services/action-updater.service';
import { PickadateDirective } from '../../pick-a-date/pickadate.directive';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { Booking } from 'app/shared/models/booking.model';
import { Dictionary } from 'app/shared/models/dictonary.model';
import { PassengerOptionsStateService } from 'app/shared/services/passenger-options-state.service';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { ITINERARY_CONTEXT } from '../../../models/enums/context.enum';
import { Passenger } from '../../../models/passenger.model';

@Component({
    selector: 'gaweb-inclusions',
    templateUrl: './inclusions.component.html'
})
export class InclusionsComponent implements OnInit, OnChanges {
    @ViewChild(PickadateDirective) pickadateDirective: PickadateDirective; // First

    @Output() onParentBookingChanged: EventEmitter<any> = new EventEmitter();
    @Output() onChooseLaterDateChecked: EventEmitter<any> = new EventEmitter();

    private _passengers: Passenger[];
    @Input()
    set passengers(p: Passenger[]) {
        this._passengers = p;
        this.passengersText = this.getPassengersText(this.passengers);
    }
    get passengers(): Passenger[] {
        return this._passengers;
    }
    @Input() name: string;
    @Input() tourGuid: string;
    @Input() requiresUsageDate: boolean;
    @Input() bookingGuid: string;
    @Input() selectedDate: string;
    inclusionDate: string;
    @Input() bookDaysPriorTo: number;
    @Input() operatingDays: string;
    @Input() showUsageDate: boolean;
    @Input() tourGuids: string[];
    @Input() bookingGuids: string[];
    @Input() idx: number;
    private _productType: ProductTypeUrl;
    @Input()
    set productType(value: number) {
        this._productType = value;
        this.productTypeName = ProductTypeUrl[this._productType];
    }
    get productType(): number {
        return this._productType;
    }
    @Input() fareTypeCode: string;
    @Input() fareTypeCurrency: string;
    @Input() fareTypeCurrencyAmount: number;
    @Input() sendConfirmation: boolean;
    @Input() loadedBooking: Booking;
    @Input() passengerCounts: Dictionary<FareTypeChangedEvent>;

    @Input() supplierName: string;
    @Input() supplierPhone: string;
    @Input() purchaseNum: string;
    isMyGreyhound: boolean;
    passengersText: string;
    @Input()
    set context(c: ITINERARY_CONTEXT) {
        this.isMyGreyhound = c === ITINERARY_CONTEXT.MY_GREYHOUND;
    }

    productTypeName: string;
    minimumDate: Date = new Date();

    public value: Date = new Date();
    isDisabled: boolean;
    constructor(private travelPackageService: TravelProductService,
        private actionUpdaterService: ActionUpdaterService,
        private passengerOptionsStateService: PassengerOptionsStateService) {
        this.isDisabled = false;
    }

    ngOnInit() {
        if (this.selectedDate === GxConstants.MIN_DATE) {
            this.selectedDate = null;
        }
        if (this.bookDaysPriorTo === -1) {
            this.minimumDate = new Date();
        } else {
            this.minimumDate = moment().add(this.bookDaysPriorTo + 1, 'days').toDate();
        }
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['selectedDate'] && changes['selectedDate'].isFirstChange()) {
            const sd = changes['selectedDate'].currentValue;
            if (!!sd && sd !== GxConstants.MIN_DATE) {
                this.inclusionDate = sd;
            }
            this.valueChange(sd, changes['selectedDate'].isFirstChange());
        }
        if (!!changes.tourGuid && !changes.tourGuids) {
            if (!this.tourGuids) {// if my-greyhound
                this.tourGuids = [this.tourGuid];
            }
        }
    }
    private getPassengersText(passengers: Passenger[]): string {
        let text = '';
        passengers.forEach(p => {
            text += p.FirstName + ' ' + p.Surname + ', ';
        });
        return text.substring(0, text.length - 2);
    }
    saveExperienceDate() {
        this.manageValueChanged();
    }
    valueChange(date, isFirstChange: boolean) {
        if (!date) {
            date = GxConstants.MIN_DATE;
        }
        const inclusionDateChanged = date !== this.selectedDate;
        this.selectedDate = date;
        if (!this.isMyGreyhound) {
            if (!isFirstChange && inclusionDateChanged) {
                this.passengerOptionsStateService.broadcastShouldDisplayDialog();
                this.manageValueChanged();
            } else if (!isFirstChange) {
                this.onParentBookingChanged.emit({
                    'bookings': null,
                    'inclusionDateChanged': false
                });
            }
        }

    }
    onChooseLaterDateCheckedFunction(value: boolean) {
        this.isDisabled = value;
        if (this.selectedDate === GxConstants.MIN_DATE) {
            this.emitOnChooseLaterDateCheckedProcessing(null, value);
        } else {
            this.selectedDate = GxConstants.MIN_DATE;
            this.manageValueChanged();
        }

    }
    /**
     * Function used either when the user selects a date or he checks the checkbox to disable the datepicker
     */
    private manageValueChanged() {
        const _updateSequentially = async (callsToMake: Observable<any>[]) => {
            const idLastCall = callsToMake.length - 1;
            let i = 0;
            let bookings = [];
            for (const call of callsToMake) {
                try {
                    let bookingsResponse = await call.toPromise();
                    if (!Array.isArray(bookingsResponse)) {
                        bookingsResponse = [bookingsResponse];
                    }
                    bookings = [...bookings, ...bookingsResponse];
                    if (i === idLastCall) {
                        this.setInclusionDate(this.selectedDate);
                        if (this.selectedDate === GxConstants.MIN_DATE) {
                            this.onChooseLaterDateCheckedProcessing(bookings, this.isDisabled);
                        } else {
                            this.valueChangeProcessing(bookings);
                        }
                    }
                } catch (err) {
                    this.actionUpdaterService.onError(err);
                }
                i++;
            }
        };
        let updateInclusionFunc, options;
        const calls = [];
        let bookingGuid = this.bookingGuid;
        const selectedDateToBook = this.selectedDate === GxConstants.MIN_DATE ? '' : this.selectedDate;
        switch (this.productType) {
            case ProductTypeUrl.accommodation:
            case ProductTypeUrl.experience:
                if (!!this.loadedBooking) { // pay using kms
                    const products: ProductType[] = this.getProductTypesFromFareTypeCounts();
                    const addProductAndPassengerToBookingOptions =
                        new AddProductAndPassengerToBookingOptions(this.loadedBooking.BookingGuid);
                    addProductAndPassengerToBookingOptions.Products = products;
                    options = addProductAndPassengerToBookingOptions;
                    updateInclusionFunc = this.travelPackageService.addProductAndPassengerToBooking;
                    updateInclusionFunc.call(this.travelPackageService, options)
                        .subscribe((bookings) => {
                            this.setInclusionDate(this.selectedDate);
                            if (this.selectedDate === GxConstants.MIN_DATE) {
                                this.onChooseLaterDateCheckedProcessing(bookings, this.isDisabled);
                            } else {
                                this.valueChangeProcessing(bookings);
                            }
                        },
                            this.actionUpdaterService.onError);
                } else {
                    updateInclusionFunc = this.travelPackageService.updateTourOnBooking;
                    // there is just one tour visible but we have to update all of them
                    this.tourGuids.forEach((tourGuid) => {
                        options = new UpdateTourOnBookingOption(bookingGuid, tourGuid, selectedDateToBook,
                            this.fareTypeCode, this.fareTypeCurrency, this.fareTypeCurrencyAmount, this.sendConfirmation);
                        calls.push(updateInclusionFunc.call(this.travelPackageService, options));
                    });
                    _updateSequentially(calls);
                }
                break;
            case ProductTypeUrl.package:
            default:
                // cases:
                // (1) 1 Booking with Package with 1 Inclusion)
                // (2) 1 Booking with Package with more than 1 Inclusion)
                // 3) Bookings with one Package with 1 Inclusion or more each
                updateInclusionFunc = this.travelPackageService.updateSingleInclusions;

                this.tourGuids.forEach((tourGuid: string, index: number) => {
                    bookingGuid = !!this.bookingGuids ?
                        this.bookingGuids[index]
                        : this.bookingGuid; // multiple bookings or one booking with multiple inclusions
                    options = new UpdateInclusionsOptions(selectedDateToBook, bookingGuid, tourGuid);
                    calls.push(updateInclusionFunc.call(this.travelPackageService, options));
                });
                _updateSequentially(calls);
        }
    }
    private setInclusionDate(date: string): void {
        this.inclusionDate = date;
    }
    private valueChangeProcessing(bookings: Booking[]) {
        this.actionUpdaterService.announceSuccess('Experience date updated successfully');
        this.onParentBookingChanged.emit({
            'bookings': bookings,
            'inclusionDateChanged': true
        });
    }
    getOperatingDaysAsArray() {
        const array = this.operatingDays.split(/\W/).filter(a => a)
        return array.map(a => Number.parseInt(a) + 1);
    }

    showCalendar($event) {
        $event.stopPropagation();
        this.pickadateDirective.openPickaDate();
    }

    getPlaceholder() {
        let placeholder;
        if (this.isDisabled) {
            placeholder = 'Open-dated';
        } else {
            placeholder = 'Choose date';
            if (this.requiresUsageDate) {
                placeholder += '*';
            }
        }

        return placeholder;
    }

    private getProductTypesFromFareTypeCounts() {
        const products: ProductType[] = <ProductType[]>_(this.passengerCounts).map((f) => {
            if (f.count > 0) {
                /* const p = new ProductType(this.travelPackageService.currentProduct.tourReference,
                    f.fareType.fareTypeCode, f.count, 'Experience'); */
                const p = new ProductType(this.travelPackageService.currentProduct.tourReference,
                    f.fareType.fareTypeCode, 1, 'Experience');
                p.DateToBook = this.selectedDate;
                const list = _.fill(Array(f.count), p);

                return list;
            }
        }).flatten().compact().value();
        return products;
    }
    private onChooseLaterDateCheckedProcessing(bookings: Booking[], value: boolean) {
        this.emitOnChooseLaterDateCheckedProcessing(bookings, value);
    }
    private emitOnChooseLaterDateCheckedProcessing(bookings: Booking[], value: boolean) {
        let tourGuidArr = [this.tourGuid];
        if (!!this.tourGuids && !!this.tourGuids[0]) {
            tourGuidArr = this.tourGuids;
        }
        this.onParentBookingChanged.emit(
            {
                'bookings': bookings,
                'inclusionsTourGuidDisabledOrEnabled': tourGuidArr,
                'isDisabled': value
            }
        );
    }
    reset() {
        if (this.selectedDate !== GxConstants.MIN_DATE) {
            this.selectedDate = GxConstants.MIN_DATE;
            this.travelPackageService.updateInclusions(new UpdateInclusionsOptions(GxConstants.MIN_DATE, this.bookingGuid, this.tourGuid))
                .subscribe((bookings) => {
                    this.onParentBookingChanged.emit(
                        {
                            'bookings': bookings
                        }
                    );
                },
                    this.actionUpdaterService.onError);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/inclusions/inclusions.component.ts